import { render } from "./Informations.vue?vue&type=template&id=039c7400&scoped=true"
import script from "./Informations.vue?vue&type=script&lang=js"
export * from "./Informations.vue?vue&type=script&lang=js"

import "./Informations.vue?vue&type=style&index=0&id=039c7400&lang=scss&scoped=true"

import exportComponent from "/Users/khalid/Sites/sathoan/echosea/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039c7400"]])

export default __exports__